/**
 * Copyright (c) 2023 Gitpod GmbH. All rights reserved.
 * Licensed under the GNU Affero General Public License (AGPL).
 * See License.AGPL.txt in the project root for license information.
 */

import { type FC } from "react";

import { Delayed } from "@/components/podkit/loading/Delayed";

type Props = {
    size?: number;
    delay?: boolean;
};
export const LoadingState: FC<Props> = ({ delay = true }) => {
    // TODO(mads): This is a temporary workaround. We should get of this component entirely and instead ensure
    // that each component handles it's loading state appropriately.
    // Returning null here ensures that there isn't a flicker between the index.html loading screen and this loading screen
    let loader = null;

    if (delay) {
        loader = <Delayed>{loader}</Delayed>;
    }

    // as the loading state might be empty, we need to add a data-testid to make it testable
    return <div data-testid="loading-state">{loader}</div>;
};
